export default __webpack_public_path__ + "static/media/hamburger.0d5c44fb.png";